import axios from 'axios';
export const dashboardMethodCorporateEmail = {
    emailfixersorter(){
        console.log("emailfixersorter called");
        axios({
        method: "post",
        url: this.baseAPIURL+"/apiv3/getemailinfo.json",
        headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "multipart/form-data",
        },
        })
        .then(response => {
          //handle succes
        if (response.data.data.email_fixed == 0) { // initial setup
            this.fix_email(this.$store.getters.auth_user);
        } else {
            this.$store.dispatch('myPersonalEmail', response.data.data.personal_email);
            this.$store.dispatch('myCorporateEmail', response.data.data.corporate_email);
        }

        }).catch(error => {
            console.log("Error: "+ error);
            this.moshaToast("Error!", { type: "danger" });
        });
    },

    fix_email(current_email){
        var data = {
        "email": current_email,
        }
        
        axios({
        method: "post",
        url: this.baseAPIURL+"/apiv3/emailchecker.json",
        headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "multipart/form-data",
        },
        data: data,
        })
        .then(response => {
        
        if (response.data.data.type == "corporate") {
            var insertType = "work";
        } else {
            insertType = "personal";
        }

        var dataSorter = {
            "email": current_email,
            "type": insertType,
        }

        axios({
        method: "post",
        url: this.baseAPIURL+"/apiv3/emailsorter.json",
        headers: {
            "auth": this.$store.getters.auth_token,
            "Content-Type": "multipart/form-data",
        },
        data: dataSorter,
        })
        .then(response => {
            console.log(response.data.message);

            if (insertType == "work") {
                this.$store.dispatch('myCorporateEmail', current_email);
            } else {
                this.$store.dispatch('myPersonalEmail', current_email);
            }
        });
        }).catch(error => {
            console.log("Error: "+ error);
            this.moshaToast("Error!", { type: "danger" });
        });
    },
};